import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { CreateNavigation } from "@/features/navigation/components/create-navigation";
import { NavigationList } from "@/features/navigation/components/navigation-list";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

function NavigationPage() {
  const { t } = useTranslation();
  const { congress } = useCongress();

  return (
    <div className="flex flex-col">
      <title>{pageTitle(t("meta.navigation"))}</title>
      <div className="ml-auto">
        <CreateNavigation />
      </div>

      <NavigationList congressId={congress.id} />
    </div>
  );
}

export { NavigationPage };
